'use strict';

var SortableLib = require('./sortable.js');

window.Sortable = SortableLib.default || SortableLib;
